import { render, staticRenderFns } from "./StkP.vue?vue&type=template&id=8813da56"
import script from "./StkP.vue?vue&type=script&lang=js"
export * from "./StkP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports